export const generateProjectPath = (projectFolder, path = '') => {
  let generatedPath = path
  if (projectFolder.subFolders.length) {
    generatedPath = `${generatedPath}/${projectFolder.subFolders[0].name}`
    return generateProjectPath(projectFolder.subFolders[0], generatedPath)
  }
  return generatedPath || '/'
}
